// extracted by mini-css-extract-plugin
module.exports = {"color-off-white":"#f8f8f8","colorOffWhite":"#f8f8f8","large":"only screen and (min-width: 992px)","homepageRail":"_2slOd","homepageRailList":"_16v2c"};